export type ToolCategory = 'inventory' | 'recipes' | 'orders' | 'menus' | 'waste' | 'suppliers' | 'general';

export interface ToolCall {
  name: string;
  result?: string;
}

export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  toolCalls?: ToolCall[];
}

export interface StreamEvent {
  type: 'text' | 'tool_use' | 'tool_result' | 'done' | 'error' | 'categories' | 'conversation' | 'title';
  content?: string;
  toolName?: string;
  categories?: ToolCategory[];
  conversationId?: string;
}

export interface Conversation {
  id: string;
  title: string;
  createdAt: string;
  updatedAt: string;
  messageCount: number;
}

export class ChatError extends Error {
  constructor(
    public readonly statusCode: number,
    message: string
  ) {
    super(message);
    this.name = 'ChatError';
  }
}
